import { useContext, useEffect, useState } from 'react'
import { FormikError, Loader } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import { CheckAnimationIcon } from '@nv/images/design/check-animation-icon'
import { AdminVoterService } from '@nv/services'
import fr from 'date-fns/locale/fr'
import { useFormik } from 'formik'
import { registerLocale } from 'react-datepicker'
import ReactDatePicker from 'react-datepicker'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import styles from './ReportsDlDateSelect.module.scss'
import 'react-datepicker/dist/react-datepicker.css'

registerLocale('fr', fr)

export const ReportsDlDateSelect = ({ userType }) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const [downloadView, setDownloadView] = useState('dateSelect')
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const formik = useFormik({
    initialValues: {
      startDate: null,
      endDate: null,
    },
    validationSchema: Yup.object().shape({
      startDate: Yup.date().typeError(t('admin.reports.validations.startDate')).required(t('admin.reports.validations.startDate')),
      endDate: Yup.date().typeError(t('admin.reports.validations.endDate')).required(t('admin.reports.validations.endDate')),
    }),
    onSubmit: () => {
      downloadReport(formik.values.startDate, formik.values.endDate)
    },
  })

  const downloadReport = async (startDate, endDate) => {
    setDownloadView('isDownloading')
    try {
      const formData = {
        userType,
        startDate,
        endDate,
      }
      const res = await AdminVoterService.getAuthLogReport(formData, currentLanguage)
      if (res?.success) {
        // @ts-ignore
        const href = URL.createObjectURL(res.data)
        const link = document.createElement('a')
        link.download = `Authentication Logs - ${userType}`
        link.href = href
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setDownloadView('isDownloaded')
      } else {
        alert(t('errors.error'))
      }
    } catch (error) {
      alert(t('errors.error'))
    }
  }

  useEffect(() => {
    setHeaderLabel(t('admin.reports.generateReport'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      downloadView === 'dateSelect'
        ? { text: t('buttons.download'), onClick: formik.handleSubmit }
        : { text: t('buttons.ok'), onClick: onClose },
    ])
  }, [downloadView])

  return (
    <>
      {downloadView === 'isDownloading' && (
        <div className={styles['container__small']}>
          {t('admin.reports.downloading')}
          <Loader />
        </div>
      )}

      {downloadView === 'isDownloaded' && (
        <div className={styles['container__small']}>
          <span className={styles['svg']}>
            <CheckAnimationIcon />
          </span>
          {t('admin.reports.downloadSuccess')}
        </div>
      )}

      {downloadView === 'dateSelect' && (
        <div className={styles['container']}>
          <label htmlFor='start-date-picker' className={styles['label']}>
            {t('admin.reports.selectDateRange')}
          </label>
          <ReactDatePicker
            id='date-picker'
            selected={formik.values.startDate}
            onChange={(dates) => {
              const [start, end] = dates
              formik.setFieldValue('startDate', start)
              formik.setFieldValue('endDate', end)
            }}
            className={styles['datePicker']}
            locale={currentLanguage}
            maxDate={new Date()}
            startDate={formik.values.startDate}
            endDate={formik.values.endDate}
            selectsRange
          />
          <FormikError formik={formik} fieldName='startDate' />
          <FormikError formik={formik} fieldName='endDate' />
        </div>
      )}
    </>
  )
}
